import { Navigate } from 'react-router-dom';
import LocalStorageUtils from 'utils/LocalStorage';

export default function GetStartedPage() {
  const isAuthenticated = Boolean(LocalStorageUtils.jwtToken.get());

  if (!isAuthenticated) return <Navigate to="/" replace />;
  return <Navigate to="/app/tenant-selection?mode=manage" replace />;
}
